module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1119.3f36cc5a.png";